import React from "react";
import { Link } from "react-router-dom";
import "../styles/Home.css";

const Terms = () => {
  return (
    <div className="gybtc-container">
      <header className="gybtc-header scrolled">
        <div className="gybtc-header-content">
          <div className="gybtc-logo-container">
            <img
              src="/gybtc-logo.png"
              alt="Grow Your BTC Logo"
              className="gybtc-logo"
            />
          </div>

          <nav className="gybtc-nav">
            <Link to="/" className="gybtc-nav-link">Home</Link>
            <Link to="/faq" className="gybtc-nav-link">FAQ</Link>
            <Link to="/privacy" className="gybtc-nav-link">Privacy</Link>
            <Link to="/disclaimer" className="gybtc-nav-link">Disclaimer</Link>
            <a href="/book" className="gybtc-btn-nav-cta">Book 1:1</a>
          </nav>
        </div>
      </header>

      <section className="gybtc-about" style={{ paddingTop: "140px", minHeight: "100vh" }}>
        <div className="gybtc-section-header">
          <h1 className="gybtc-section-title">Terms of Use</h1>
        </div>

        <div className="gybtc-about-grid" style={{ gridTemplateColumns: "1fr" }}>
          <div className="gybtc-about-card">
            <p className="gybtc-about-card-text">
              By using Grow Your BTC, you agree to these terms.
            </p>

            <h3 className="gybtc-about-card-title">Educational purpose</h3>
            <p className="gybtc-about-card-text">
              This website and its content are for educational and informational purposes only.
            </p>

            <h3 className="gybtc-about-card-title">User responsibility</h3>
            <p className="gybtc-about-card-text">
              You are responsible for your own Bitcoin decisions, wallet use, security
              practices, tax obligations, and legal compliance.
            </p>

            <h3 className="gybtc-about-card-title">No guarantees</h3>
            <p className="gybtc-about-card-text">
              Grow Your BTC does not guarantee results, gains, portfolio performance, or
              protection from loss.
            </p>

            <h3 className="gybtc-about-card-title">Bookings and services</h3>
            <p className="gybtc-about-card-text">
              Any 1:1 guidance, calls, or educational services are provided in good faith for
              educational support. Availability, pricing, and format may change over time.
            </p>

            <h3 className="gybtc-about-card-title">Acceptable use</h3>
            <p className="gybtc-about-card-text">
              You agree not to misuse the website, attempt unauthorised access, copy content
              unlawfully, or use the service for illegal or abusive purposes.
            </p>

            <h3 className="gybtc-about-card-title">Third-party services</h3>
            <p className="gybtc-about-card-text">
              The website may link to third-party services, apps, exchanges, or payment tools.
              Their terms apply separately.
            </p>

            <h3 className="gybtc-about-card-title">Changes</h3>
            <p className="gybtc-about-card-text">
              These terms may be updated at any time without prior notice.
            </p>
          </div>
        </div>
      </section>

      <footer id="footer" className="gybtc-footer">
        <div className="gybtc-footer-content">
          <p className="gybtc-footer-text">
            © 2025 Grow Your BTC • <Link to="/privacy">Privacy Policy</Link> •{" "}
            <Link to="/terms">Terms</Link> • <Link to="/disclaimer">Disclaimer</Link> •{" "}
            <Link to="/faq">FAQ</Link>
          </p>
        </div>
      </footer>
    </div>
  );
};

export default Terms;
